import { ROUTES } from 'router/routes';

import { VARIANT_UI } from 'constants/ui';

import NotificationsService from 'services/notifications/NotificationsService';
import NavigationService from 'services/navigation/NavigationService';
import JobService from 'services/job/JobService';
import TokenService from 'services/auth/TokenService';

import * as authActions from 'store/auth/actions';
import { store } from 'store/store';

export function ejectErrorMessage(errors) {
  const status = errors?.response?.status ?? 'Unknown';
  return errors?.response?.data?.message ?? `Error code #${status}`;
}

export function handleRequestError(error, text) {
  const showError =
    error?.response?.status !== 403 && error?.response?.status !== 401;

  if (showError) {
    NotificationsService.throwNotification({
      title: 'Request error',
      text: ejectErrorMessage(error || text),
      variant: VARIANT_UI.danger,
      delay: 5000,
    });
  }
}

export function tokenRequestInterceptor(config) {
  const { headers } = config;
  const token = TokenService.getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return config;
}

export function errorResponseInterceptor(error) {
  const { response = {} } = error;
  const { status, config } = response;

  const url = config.url || '';
  const isUrlGetJob = JobService.checkUrlGetJob(url);

  const signUpConfirmPathName = ROUTES.signUpConfirm.path.replace(':token', '');
  const isSignUpConfirmPage =
    window?.location?.pathname?.includes(signUpConfirmPathName) || false;

  const isToken = !!error.config?.headers?.Authorization;

  if ((status === 401 && isToken) || (status === 403 && !isToken)) {
    NavigationService.navigateToPath(ROUTES.signOut.path);
  }

  if (status === 403 && !isUrlGetJob) {
    NavigationService.navigateToDefaultPath();
  }

  if (status === 404 && !isSignUpConfirmPage && !isUrlGetJob) {
    NavigationService.navigateToPath(ROUTES.emptyPage.path);
  }

  if (status === 400 && isToken) {
    store.dispatch(authActions.getUserData.start());
  }

  return Promise.reject(error);
}
